import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter,ViewChild, ElementRef,Directive } from '@angular/core';
import { ReporteLiquidacionService } from '../../../services/reporte-liquidacion.service';
import { HelpersService } from '../../../services/tools/helpers.service';

@Component({
  selector: 'app-save-image',
  templateUrl: './save-image.component.html',
  styleUrls: ['./save-image.component.scss']
})

export class SaveImageComponent implements OnInit {
  
  @Input() public idInversionista: any;
  @Input() public idGrupoInversionistas: number;
  @Input() public hasFiles: boolean = false;

  public loadingImage = false;
  public idComprobanteNuevo:any;
  public saving: any = false;

  constructor(private reporteLiquidacionService: ReporteLiquidacionService,
    private helpersService: HelpersService) { 
  }

  ngOnInit() {
  }

  public imageComprobante(event) {
      if (event.target.files && event.target.files.length > 0) {

        this.saving = true;
        let savedFiles = 0;
        for(let index = 0; index < event.target.files.length; index++){
          let comprobante = event.target.files[index];
          
          let parametersJSON = {
            idLiquidacion_Reporte_Inversionistas: this.idInversionista ? this.idInversionista : null,
            idLiquidacion_Reporte_Grupo_Elemento: this.idGrupoInversionistas ? this.idGrupoInversionistas : null
          };
  
          this.reporteLiquidacionService.uploadComprobanteLiquidacion(comprobante, parametersJSON)
          .subscribe(response => {
            const respuesta = response.json();

            this.hasFiles = true;
            this.saving = (++savedFiles < event.target.files.length);

          }, error => {
            this.saving = (++savedFiles < event.target.files.length);
            this.helpersService.httpGlobalError(error, false);
          });
        }
        
        this.loadingImage = true;
    }
  }

  public onAfterClearComprobantes(){
    this.hasFiles = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tools/save-image/save-image.component.ts